import dayjs from 'dayjs';
import { ColorValues, Typography } from '@banhala/ui-kit';
import { getDayOfWeek, isNil, isNotNil } from 'shared/src/utils';
import { useMyInfo } from 'shared/src/queries';
import { TitleContent } from './TitleContent';
import { useGoodsBasic } from '../../../queries/useGoodsBasic';
import { useGetDeliveryOrderDeadlineTime } from '../../../hooks/useGetDeliveryOrderDeadlineTime';
import { useRemainTimeTextFormat } from '../../../hooks/useRemainTimeTextFormat';

const RURAL_REGION_ADDITION_DAYS = 2;

export const ThirdPLArrivalExpectedDay = () => {
  const { data: goodsBasic } = useGoodsBasic();
  const { data: myInfo } = useMyInfo();
  const deadline = useGetDeliveryOrderDeadlineTime(goodsBasic);
  const remainTime = isNotNil(deadline)
    ? deadline.format('YYYY-MM-DD HH:mm:ss')
    : null;
  const { text, isTimeOver } = useRemainTimeTextFormat(remainTime);

  if (isNil(remainTime)) return null;

  const isDefaultAddressRural = myInfo?.is_default_address_rural === true;

  // 도서산간: 타이머 없이 도착일(기본 도착일 + 2일)만 표시
  if (isDefaultAddressRural) {
    const baseOffsetDays = isTimeOver ? 2 : 1;
    const arrivalDay = dayjs().add(
      baseOffsetDays + RURAL_REGION_ADDITION_DAYS,
      'day',
    );
    return (
      <TitleContent title={'도착예정'}>
        <Typography type={'body2'} color={'content_primary'}>
          지금 주문하면{' '}
          <Typography type={'subtitle2'} color={'content_primary'}>
            {arrivalDay.format('M/D')}({getDayOfWeek(arrivalDay)})
          </Typography>{' '}
          도착
        </Typography>
      </TitleContent>
    );
  }

  // 컷오프 후: 타이머 없이 "지금 주문하면 모레 M/D(요일) 도착"
  if (isTimeOver) {
    const arrivalDay = dayjs().add(2, 'day');
    return (
      <TitleContent title={'도착예정'}>
        <Typography type={'body2'} color={'content_primary'}>
          지금 주문하면{' '}
          <Typography type={'subtitle2'} color={'content_primary'}>
            모레 {arrivalDay.format('M/D')}({getDayOfWeek(arrivalDay)})
          </Typography>{' '}
          도착
        </Typography>
      </TitleContent>
    );
  }

  // 마감 전: "{카운트다운} 내 주문하면 내일 M/D(요일) 도착"
  const arrivalDay = dayjs().add(1, 'day');
  return (
    <TitleContent title={'도착예정'}>
      <Typography type={'body2'} color={'content_primary'}>
        <Typography type={'subtitle2'} rawColor={ColorValues.pink30}>
          {text}
        </Typography>{' '}
        내 주문하면{' '}
        <Typography type={'subtitle2'} color={'content_primary'}>
          내일 {arrivalDay.format('M/D')}({getDayOfWeek(arrivalDay)})
        </Typography>{' '}
        도착
      </Typography>
    </TitleContent>
  );
};
